import PropTypes from 'prop-types';

export const SiteResource = {
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    slugUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
    current_status: PropTypes.string.isRequired,
    visited: PropTypes.bool,
    state: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        short: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    county: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        }).isRequired,
    ).isRequired,
};
